import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/categorias-gamp-sistemas-informatizados")({
  head: () => buildRouteHead("/es/categorias-gamp-sistemas-informatizados", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/downloads", replace: true });
  },
});
